import React, { useEffect, useRef, useState } from "react";
import IconSent from "@/components/icons/IconSent";
import ButtonComponent from "@/components/button/Button";
import { Flex, Input } from "antd";
import { getGuideConversations } from "@/services/guides/getGuideConversations";
import { getChatMembers } from "@/services/users/chatMembers";

import { getUserInfo } from "@/reducers/commonSlice";
import { useSelector } from "react-redux";
import { getChatMessages } from "@/services/users/chatMessages";
import socket from "@/socket";
const StudentConversation = ({ student, key }) => {
  const [chat, setChat] = useState([]);
  const [message, setMessage] = useState("");
  const [purchases, setPurchases] = useState([]);
  const [chatMembers, setChatMembers] = useState([]);
  const [groupId, setGroupId] = useState("");
  const conversationRef = useRef(null);
  const token = localStorage.getItem("token");
  const userInfo = useSelector(getUserInfo);

  const handlePurchaseId = (metadata) => {
    if (metadata?.groupChatId) {
      setGroupId(metadata.groupChatId);
    }
  };

  const fetchMessages = async (groupID) => {
    if (groupID) {
      try {
        // Fetch chat messages after chat members
        const chatMembersData = await fetchChatMembers(groupID);
        const chatMessagesResponse = await getChatMessages(groupID);
        const chatMessages = chatMessagesResponse?.messages?.rows || [];
        // Merge chat messages with member details
        const mergedMessages = chatMessages.map((message) => {
          const formatedMessage = matchUserProfile(message, chatMembersData);
          return formatedMessage;
        });
        // Set the merged chat data
        setChat(mergedMessages);
        setTimeout(() => {
          scrollToBottom();
        }, 500);
      } catch (error) {
        setChat([]);
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchChatMembers(groupId);
      fetchMessages(groupId);
    }
  }, [groupId]);

  const fetchChatMembers = async (groupId) => {
    const chatMembersResponse = await getChatMembers(groupId);
    const chatMembersData = chatMembersResponse?.members || [];
    setChatMembers(chatMembersData);
    return chatMembersData;
  };

  const matchUserProfile = (message, chatMembers) => {
    const matchProfile = chatMembers?.find((m) => m.id === message.senderId);
    return {
      ...message,
      name: matchProfile?.name,
      profileImgUrl: matchProfile?.profileImgUrl,
    };
  };

  useEffect(() => {
    if (groupId) {
      // Register the user with the backend after login
      socket.emit("joinGroup", { token, groupId });

      // Listen for incoming group messages
      socket.on("receiveGroupMessage", async (data) => {
        const chatMembers = await fetchChatMembers(groupId);
        const updated_message = matchUserProfile(data, chatMembers);
        setChat((prevChat) => [...prevChat, updated_message]);
        setTimeout(() => {
          scrollToBottom();
        }, 500);
      });

      return () => {
        socket.off("receiveGroupMessage");
      };
    }
  }, [groupId]);

  console.log(groupId, "groupId");
  const StudentPurchase = ({ data }) => {
    return data?.map((x, i) => {
      return (
        <div
          key={i}
          className="card"
          onClick={() => handlePurchaseId(x.metadata)}
          style={{
            paddingRight: "10px",
            paddingLeft: "10px",
          }}
        >
          <Flex className="h-100" justify="center" align="center">
            <span className="body-b1">{x.productName}</span>
          </Flex>
        </div>
      );
    });
  };

  console.log(student);
  useEffect(() => {
    if (student.id) {
      getGuideConversations(student.id)
        .then((res) => {
          setPurchases(res[0]?.purchases);
          setGroupId("");
        })
        .catch((err) => console.log(err));
    }
  }, [student.id]);

  console.log(purchases, "purchases");

  const scrollToBottom = () => {
    if (conversationRef.current) {
      conversationRef.current.scrollTop = conversationRef.current.scrollHeight;
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    const messageData = {
      token,
      groupId, // Array of receiver emails
      body: { text: message },
    };
    try {
      // Emit the message to the receiver via socket
      socket.emit("sendGroupMessage", messageData);
      // Update local state
      setChat((prevChat) => [
        ...prevChat,
        {
          senderId: userInfo?.user?.email,
          body: messageData.body,
          name: userInfo?.user?.firstName + userInfo?.user?.lastName,
          profileImgUrl: userInfo?.profileImgUrl,
        },
      ]);
      setMessage("");
    } catch (error) {
      console.error("Error sending message:", error);
    }
    setTimeout(() => {
      scrollToBottom();
    }, 500);
  };
  useEffect(() => {
    setGroupId("");
  }, [key]);

  return (
    <div className="student-conversation-wrapper">
      {groupId ? (
        <>
          <div className="content-wrapper" ref={conversationRef}>
            {chat?.map((msg, index) => (
              <Flex justify="space-between" key={index}>
                <Flex align="center" gap={8} style={{ paddingBottom: "10px" }}>
                  <div className="profile-picture">
                    <div className="icon">
                      <img
                        src={msg?.profileImgUrl || "/assets/images/defaultProfile.jpeg"}
                        alt="profile"
                      />
                    </div>
                  </div>
                  <div
                    key={index}
                    className={msg.name === userInfo?.user?.email ? "my-message" : "other-message"}
                  >
                    <div className="username">@{msg?.name}</div>
                    {msg.body.text}
                  </div>
                </Flex>
              </Flex>
            ))}
          </div>
          <form onSubmit={sendMessage} className="message-form">
            <div className="conversation-input">
              <div className="input-container" style={{ overflow: "hidden" }}>
                <div className="emoji-icon">
                  {/* <IconEmoji width={30} height={30} color="#000" /> */}
                </div>

                <div className="input">
                  <Input
                    name="message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Type your message here..."
                    style={{
                      height: 56,
                      resize: "none",
                      width: "100%",
                    }}
                  />
                </div>
              </div>

              <div className="send-button">
                <ButtonComponent
                  shape="circle"
                  varient="primary"
                  disabled={!message.length}
                  icon={<IconSent width={30} height={30} color="#fdfefe" />}
                  htmlType="submit"
                />
                {/* <button className="send-button-box" type="submit" dis>
                            <IconSent width={30} height={30} color="#fdfefe" />
                          </button> */}
              </div>
            </div>
          </form>
        </>
      ) : (
        <div className="purchases-wrapper">
          <div className="purchases-grid">
            <StudentPurchase data={purchases} />
          </div>
        </div>
      )}
    </div>
  );
};

export default StudentConversation;
